import { replaceRichTextReferences } from '../../../../inputs/rich-text-advanced/render/postprocess-html/replaceRichTextReferences.tsx';
import { encodeDataReference } from '../../compute/input/nodes/ComputeExpressionReferenceNode.tsx';
import { ReferenceType } from '../IReference.ts';
import { normalizeVirtualReference } from './normalizeVirtualReference.ts';

/**
 * I testi RTE contengono le Reference serializzate in base64,
 * quindi `findVirtualReferencesInWidget` non può trovarle.
 * Questa funzione normalizza le Reference in un testo RTE.
 */
export function normalizeVirtualRefsRte(
  text: string | null | undefined,
  prefix: string,
) {
  return replaceRichTextReferences(text, (ref, encoded, match) => {
    if (ref.type !== ReferenceType.VirtualColumn) return match;

    const normalizedRef = normalizeVirtualReference(ref, prefix);
    // Sostituiamo la Reference serializzata con la Reference normalizzata
    return match.replace(encoded, encodeDataReference(normalizedRef));
  });
}
